export function onReturnToStaleApp(handler, minutes = 20) {
  let lastBlurredAt

  window.addEventListener('focus', () => {
    if (!lastBlurredAt) return
    const now = Date.now()
    const minutesSinceBlur = ((now - lastBlurredAt) / 1000) / 60
    if (minutesSinceBlur < minutes) return
    handler()
  })

  window.addEventListener('blur', function() {
    lastBlurredAt = Date.now()
  })
}
